import { List, Descriptions, Button, Space, Popconfirm, Typography, Progress, Divider, Popover, Row, Col, message } from "antd";
import PageHeader from "./../../../../components/Elements/PageHeader";
import { CheckOutlined, CloseOutlined, FileOutlined, RollbackOutlined } from "@ant-design/icons";
import moment from "moment";
import { Link as Direction } from "react-router-dom";
import { addDoc, collection, deleteDoc, doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../../../../firebase/config";
import { useAuthContext } from "../../../../hooks/useAuthContext";
import adminNotifStore from "../../../../store/adminNotifStore";
import { loadingSpin } from "../../../../components/Elements/LoadingSpinner";

const { Link, Text } = Typography;

export default function RecalculateOrders() {
  const { user } = useAuthContext();
  //data for managers to see sent back prices
  const { adminOrders } = adminNotifStore();

  // Use the adminOrders state
  console.log(adminOrders); // Example usage

  if (!adminOrders) {
    return <>{loadingSpin(25)}</>;
  }

  //approves the price
  const updateData = async (e, docid, dokument) => {
    e.preventDefault();
    //price ref
    const ref = doc(db, "orders", docid);

    //notifications refference
    const notifRef = collection(db, "notifications");

    //Approve the price
    await updateDoc(ref, {
      updated: serverTimestamp(),
      orderForAdmin: false,
      orderStatus: 1,
      changedByDesigner: false,
    })
      .then(() => {
        try {
          addDoc(notifRef, {
            date: serverTimestamp(),
            desc: `Admin ${user.email} has approved price "${dokument.selectedProduct.product.productName}"`,
            seen: false,
            type: "Approved Order",
            uid: dokument.uid,
            userEmail: dokument.user,
            orderId: dokument.id,
            productName: dokument.selectedProduct.product.productName,
            clientId: dokument.client.id,
          });
        } catch (error) {
          message.error("error", "Login Error", error.message);
        }
      })
      .then(() => {
        message.success("Price has been approved!");
      })
      .catch((err) => {
        message.error(err.message);
      });
  };

  //deleting the price
  const deleteData = async (e, docid, item) => {
    e.preventDefault();

    //notifications refference
    const notifRef = collection(db, "notifications");

    //price ref
    const ref = doc(db, "orders", docid);

    //deletes the price
    await deleteDoc(ref)
      .then(() => {
        Notification("warning", "Deleted!", "Price has been deleted!");
      })
      .then(() => {
        try {
          addDoc(notifRef, {
            date: serverTimestamp(),
            desc: `Admin ${user.email} has deleted the price "${item.selectedProduct.product.productName}"`,
            seen: false,
            type: "Deleted Price",
            uid: item.uid,
            userEmail: item.user,
            productId: item.id,
            productName: item.selectedProduct.product.productName,
            clientId: item.client.id,
          });
        } catch (error) {
          Notification("error", "Login Error", error.message);
        }
      })
      .catch((err) => {
        Notification("error", "Login Error", err.message);
      });
  };

  //for regular prices
  const popupContent = (prices) => (
    <div style={{ width: "250px" }}>
      <Descriptions size="small" column={2}>
        {prices.map((data) => (
          <>
            <Descriptions.Item contentStyle={{ color: "#1677ff" }} label="Quantity">
              {data.quantity}
            </Descriptions.Item>
            <Descriptions.Item contentStyle={{ color: "#52c41a" }} label="Price">
              {data.price}
            </Descriptions.Item>
          </>
        ))}
      </Descriptions>
    </div>
  );

  //for dynamic prices
  const popupContentFixed = (prices) => (
    <div style={{ width: "250px" }}>
      <Descriptions size="small" column={2}>
        {prices.map((data) => (
          <>
            <Descriptions.Item contentStyle={{ color: "#1677ff" }} label="Quantity">
              {data.quantity}
            </Descriptions.Item>
            <Descriptions.Item contentStyle={{ color: "#52c41a" }} label="Price">
              {data.price}
            </Descriptions.Item>
          </>
        ))}
      </Descriptions>
    </div>
  );

  return (
    <div style={{ padding: 15 }}>
      <Row>
        <Col span={24}>
          <PageHeader text="Sent Back Orders" icon={<RollbackOutlined />} />
        </Col>
        <Col span={24}>
          <div style={{ backgroundColor: "white" }}>
            <List
              size="small"
              itemLayout="horizontal"
              dataSource={adminOrders && adminOrders}
              loading={!adminOrders}
              rowKey={(record) => record.id}
              renderItem={(item) => (
                <List.Item key={item.id}>
                  <Descriptions
                    key={item.id}
                    style={{ width: "100%" }}
                    labelStyle={{ fontStyle: "italic" }}
                    contentStyle={{ color: "#1677ff" }}
                    extra={[
                      <Space key="extra-buttons">
                        <Button type="primary" onClick={(e) => updateData(e, item.id, item)}>
                          Approve Price <CheckOutlined />
                        </Button>
                        {/* LINK TO RE-Calculations */}
                        <Direction state={item} to={`/unconfirmed-prices/${item.id}`}>
                          <Button type="primary" ghost>
                            Re-Calculate <RollbackOutlined />
                          </Button>
                        </Direction>
                        <Popconfirm onConfirm={(e) => deleteData(e, item.id, item)} title="Are you sure you want to delete?" okText="Yes" cancelText="No">
                          <Button danger>
                            Delete
                            <CloseOutlined />
                          </Button>
                        </Popconfirm>
                      </Space>,
                    ]}
                    title={"Client : " + item.selectedProduct.client}
                    size="small"
                    column={{
                      xxl: 4,
                      xl: 3,
                      lg: 3,
                      md: 3,
                      sm: 2,
                      xs: 1,
                    }}
                  >
                    {/* MACHINE */}
                    <Descriptions.Item label="Machine">{item.selectedProduct.machine}</Descriptions.Item>

                    {/*  CMYK COLOR */}
                    <Descriptions.Item label={item.selectedProduct.print.cmykColors > 0 ? "CMYK" : ""}>
                      {item.selectedProduct.print.cmykColors > 0 ? (
                        <>
                          {item.selectedProduct.print.cmykColors}
                          <Divider type="vertical" />
                          <Progress steps={5} status="normal" percent={item.selectedProduct.print.cmykPercent * 100} />
                        </>
                      ) : (
                        ""
                      )}
                    </Descriptions.Item>

                    {/* PRICE */}
                    <Descriptions.Item label="Price">
                      {item.selectedProduct.advanced.fixedPrice ? (
                        <>
                          <Popover
                            content={popupContentFixed(item.selectedProduct.dynamicFixedPrice)}
                            title={item.selectedProduct.product.productName}
                            trigger="click"
                          >
                            <Space>
                              <Link italic type="danger">
                                View
                              </Link>
                              <Text code italic type="danger">
                                Fixed
                              </Text>
                            </Space>
                          </Popover>
                        </>
                      ) : (
                        <>
                          <Popover content={popupContent(item.selectedProduct.dynamicPrice)} title={item.selectedProduct.product.productName} trigger="click">
                            <Link>View</Link>
                          </Popover>
                        </>
                      )}
                    </Descriptions.Item>

                    {/* PRODUCT NAME */}
                    <Descriptions.Item label="Product">{item.selectedProduct.product.productName}</Descriptions.Item>

                    {/* PANTONE COLORS */}
                    <Descriptions.Item label={item.selectedProduct.print.pantoneColors > 0 ? "Pantone" : ""}>
                      {item.selectedProduct.print.pantoneColors > 0 ? (
                        <>
                          {item.selectedProduct.print.pantoneColors}
                          <Divider type="vertical" />
                          <Progress steps={5} status="normal" percent={item.selectedProduct.print.pantonePercent * 100} />
                        </>
                      ) : (
                        ""
                      )}
                    </Descriptions.Item>

                    {/* FIXED PRICE */}

                    <Descriptions.Item label="Fixed Price?">
                      {item.selectedProduct.advanced.fixedPrice ? (
                        <>
                          <Text type="danger">Yes</Text>
                        </>
                      ) : (
                        "No"
                      )}
                    </Descriptions.Item>

                    {/* LABEL COUNT */}
                    <Descriptions.Item label="Label Count">{item.selectedProduct.labelCount}</Descriptions.Item>

                    {/* COWERING W COUNT */}
                    <Descriptions.Item label={item.selectedProduct.print.coveringWCount > 0 ? "White" : ""}>
                      {item.selectedProduct.print.coveringWCount > 0 ? (
                        <>
                          {item.selectedProduct.print.coveringWCount}
                          <Divider type="vertical" />
                          <Progress steps={5} status="normal" percent={item.selectedProduct.print.coveringWPercent * 100} />
                        </>
                      ) : (
                        ""
                      )}
                    </Descriptions.Item>

                    {/* EXTRA PROFIT */}
                    {item.selectedProduct.advanced.extraProfit !== 0 ? (
                      <Descriptions.Item label="Extra Profit">{item.selectedProduct.advanced.extraProfit}%</Descriptions.Item>
                    ) : (
                      <Descriptions.Item label="Extra Profit"> 0%</Descriptions.Item>
                    )}

                    {/* Knife */}
                    <Descriptions.Item label="Knife">{item.selectedProduct.knifeCode}</Descriptions.Item>

                    {/* VARNISH */}
                    <Descriptions.Item label={item.selectedProduct.print.varnishType !== "none" ? "Varnish" : ""}>
                      {item.selectedProduct.print.varnishType !== "none" ? (
                        <>
                          {item.selectedProduct.print.varnishType}
                          <Divider type="vertical" />
                          <Progress steps={5} status="normal" percent={item.print.varnishPercent * 100} />
                        </>
                      ) : (
                        ""
                      )}
                    </Descriptions.Item>

                    {/* CLIENTS PROFIT */}
                    <Descriptions.Item label="Client's profit">{item.selectedProduct.clientsProfit}%</Descriptions.Item>

                    {/* WIDTH/ HEIGHT */}
                    <Descriptions.Item label="Width/Height">
                      {item.selectedProduct.labelWidth} | {item.selectedProduct.labelHeight}
                    </Descriptions.Item>

                    {/* GOLD OR SILVER */}
                    <Descriptions.Item label={item.selectedProduct.print.goldOrSilver > 0 ? "Silver/Gold" : ""}>
                      {item.selectedProduct.print.goldOrSilver > 0 ? (
                        <>
                          {item.selectedProduct.print.goldOrSilver}
                          <Divider type="vertical" />
                          <Progress steps={5} status="normal" percent={item.selectedProduct.print.goldOrSilverPercent * 100} />
                        </>
                      ) : (
                        ""
                      )}
                    </Descriptions.Item>

                    {/* USER EMAIL */}
                    <Descriptions.Item label="User">{item.selectedProduct.userEmail}</Descriptions.Item>

                    {/* MATERIAL */}
                    <Descriptions.Item label="Material">{item.selectedProduct.material}</Descriptions.Item>

                    {/* RELIEF */}
                    <Descriptions.Item label={item.selectedProduct.print.relief === "Yes" ? "Relief" : ""}>
                      {item.selectedProduct.print.relief === "Yes" ? item.selectedProduct.print.relief : ""}
                    </Descriptions.Item>

                    {/* CREATED */}
                    <Descriptions.Item label="Created">
                      {moment.unix(item.selectedProduct.date.created.seconds && item.selectedProduct.date.created.seconds).format("L")}
                    </Descriptions.Item>

                    {/* FORMAT */}
                    <Descriptions.Item label="Format">
                      {item.selectedProduct.formatWidth} | Cols: {item.selectedProduct.numberOfColumns}
                    </Descriptions.Item>

                    {/* FOIL */}
                    <Descriptions.Item label={item.selectedProduct.print.foilCount > 0 ? "Foil" : ""}>
                      {item.selectedProduct.print.foilCount > 0 ? (
                        <>
                          {item.selectedProduct.print.foilColor}
                          <Divider type="vertical" />
                          <Progress steps={5} status="normal" percent={item.selectedProduct.print.foilPercent * 100} />
                        </>
                      ) : (
                        ""
                      )}
                    </Descriptions.Item>

                    {/* FILE URL */}
                    {item.selectedProduct.product.productFileUrl ? (
                      <Descriptions.Item label="Product File">
                        <Link target="_blank" href={item.selectedProduct.product.productFileUrl}>
                          <Space>
                            <FileOutlined />
                            View File
                          </Space>
                        </Link>
                      </Descriptions.Item>
                    ) : (
                      <></>
                    )}
                  </Descriptions>
                </List.Item>
              )}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}
